import { Box, Divider, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";

const CustomChips = ({ chipItems, handleClick, selectedChip, onBack }) => {
  const nav = useNavigate();
  const [backbutton, setBackbutton] = useState(false);

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      nav("/mydashboard");
    }
  };

  const getTitle = () => {
    switch (selectedChip) {
      case "Candidates":
        return "Candidates";
      case "Jobs":
        return "Total Jobs";
      default:
        return "";
    }
  };

  const titleColor =
    selectedChip === "Candidates" || selectedChip === "Jobs"
      ? "#006CB7"
      : "inherit";

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      spacing={2}
      alignItems="center"
      sx={{
        backgroundColor: "white",
        borderRadius: "10px",
        padding: "5px 10px",
      }}
    >
      {/* Square when idle, expands on hover */}
      <Box
        onClick={handleBackClick}
        onMouseEnter={() => setBackbutton(true)}
        onMouseLeave={() => setBackbutton(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          px: backbutton ? "10px" : "4px", // ← square (equal padding) when idle
          height: "28px",
          width: backbutton ? "auto" : "28px", // ← fixed square size when idle
          border: `1px solid ${backbutton ? "#3F95EA" : "#E2E8F0"}`,
          borderRadius: "6px",
          cursor: "pointer",
          backgroundColor: backbutton ? "#3F95EA" : "#fff",
          transition: "all 0.2s ease",
          overflow: "hidden",
          justifyContent: "center",
        }}
      >
        <ChevronLeftIcon
          sx={{
            fontSize: "18px",
            color: backbutton ? "#fff" : "#64748B",
            transition: "color 0.2s",
            flexShrink: 0,
          }}
        />
        {backbutton && (
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#fff",
              whiteSpace: "nowrap",
            }}
          >
            Back
          </Typography>
        )}
      </Box>

      <Typography
        variant="h6"
        sx={{
          color: titleColor,
          fontSize: "16px",
          fontWeight: 500,
          lineHeight: "normal",
        }}
      >
        <span style={{ color: "#737791" }}>Dashboard / </span>
        {getTitle()}
      </Typography>
    </Stack>
  );
};

export default CustomChips;
